export default `:host {
  box-sizing: border-box;
}

::slotted(ids-button) {
  display: block;
  height: var(--ids-module-nav-switcher-button-size);
  width: var(--ids-module-nav-switcher-button-size);
}

ids-button::part(button) {
  height: var(--ids-module-nav-switcher-button-size);
  width: var(--ids-module-nav-switcher-button-size);
}

:host([display-mode=collapsed]) ::slotted(ids-dropdown) {
  display: none;
}

::slotted(ids-dropdown) {
  margin-inline-start: var(--ids-module-nav-switcher-button-gutter-size);
  width: var(--ids-module-nav-switcher-dropdown-width);
}

.ids-module-nav-switcher {
  align-items: center;
  display: flex;
  flex-direction: row;
  position: relative;
  min-height: var(--ids-module-nav-switcher-button-size);
  margin: var(--ids-module-nav-switcher-button-gutter-size);
}
.ids-module-nav-switcher.display-mode-collapsed {
  justify-content: center;
}
.ids-module-nav-switcher.display-mode-collapsed ::slotted(ids-dropdown) {
  display: none;
}
.ids-module-nav-switcher.display-mode-collapsed ::slotted(ids-button) {
  height: var(--ids-module-nav-switcher-button-size);
  width: var(--ids-module-nav-switcher-button-size);
  padding-inline: 4px;
}
.ids-module-nav-switcher.display-mode-collapsed .ids-dropdown {
  display: none;
}
.ids-module-nav-switcher.display-mode-collapsed .ids-button {
  height: var(--ids-module-nav-switcher-button-size);
  width: var(--ids-module-nav-switcher-button-size);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
